import { Lightbulb } from "lucide-react";
import { STATUS } from "@/lib/format";

export const InsightCard = ({ insights }) => {
  if (!insights?.headline) return null;
  const bar = STATUS[insights.tone]?.bar || "bg-[#0078C1]";
  return (
    <div data-testid="insight-card" className="rise relative overflow-hidden rounded-xl border bg-card p-4 sm:p-5 shadow-sm">
      <span className={`absolute left-0 top-0 h-full w-1 ${bar}`} />
      <div className="flex gap-3">
        <span className="grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-[#F5A623]/15 text-[#B7791F]"><Lightbulb className="h-5 w-5" /></span>
        <div className="min-w-0">
          <p className="text-[10px] font-semibold uppercase tracking-widest text-muted-foreground">Kesimpulan otomatis · sesuai filter</p>
          <p data-testid="insight-headline" className="font-heading mt-0.5 text-base sm:text-lg font-semibold">{insights.headline}</p>
          {insights.points?.length > 0 && (
            <ul data-testid="insight-points" className="mt-2 grid gap-1 text-sm text-muted-foreground lg:grid-cols-2">
              {insights.points.map((p) => <li key={p} className="flex gap-2"><span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-[#0078C1]" />{p}</li>)}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};
